export const getSegmentationData = (payload) => {
  const segmentedImageRaw =
    payload?.segmented_image ||
    payload?.data?.segmented_image ||
    null

  const realHairSegmentedRaw =
    payload?.real_hair_segmented ||
    payload?.data?.real_hair_segmented ||
    null

  return {
    segmentedImageRaw,
    realHairSegmentedRaw,
  }
}

export const toImageDataUrl = (
  imageValue,
  defaultMimeType = 'image/png',
) => {
  if (!imageValue) return null

  if (imageValue.startsWith('data:image')) {
    return imageValue
  }

  return `data:${defaultMimeType};base64,${imageValue}`
}

export const getHairPredictionResult = ({
  maskedImage,
  vlmData,
}) => {
  return {
    maskedImage,
    predictedHairClass: vlmData?.hair_type,
    predictedHairDescription: vlmData?.hair_type_description,
  }
}

export const getUnknownHairPredictionResult = (maskedImage = null) => {
  return {
    maskedImage,
    predictedHairClass: 'Unknown',
    predictedHairDescription:
      'This estimate is based on the currently visible hair in your uploaded photo.',
  }
}